<!--  -->
<template>
  <div class="page">
    <van-button  style="margin-bottom:20px" size="large" @click="scanQrcode">点击扫描</van-button>
    <template v-if="isUpload">
      <van-field name="uploader" label="票码">
        <template #input>{{code}}</template>
      </van-field>
      <van-field name="uploader" label="文件上传">
        <template #input>
          <field-option-customer-info-face-uploader @change="$event => handleFieldChange($event)" />
        </template>
      </van-field>
      <van-button style="margin-top:20px" size="large" type="info" @click="submit">确定</van-button>
    </template>
  </div>
</template>

<script>
import wx from 'jweixin-module';
import { isIOS } from '../../../utils/map';
import { getMapSdk } from '../../../api/api-ticket';
import { checkCode, addFaceInfo } from '../../../api/api-check';
import FieldOptionCustomerInfoFaceUploader from '../../../components/FieldOptionCustomerInfoFaceUploader';

export default {
  components: {
    FieldOptionCustomerInfoFaceUploader,
  },
  data() {
    return {
      path: '/yx_yun_jing_tong_ticketing_client_mobile/user_info/face',
      isUpload: false,
      code: null,
      imgUrl: null,
    };
  },
  computed: {},
  watch: {},
  methods: {
    scanQrcode() {
      wx.scanQRCode({
        needResult: 1,
        scanType: ['qrcode', 'barcode'],
        success: this.handleScanSuccess,
        cancel: this.handleScanCancel,
      });
    },
    handleScanCancel() {
      this.$toast.fail('用户取消操作');
    },
    async handleScanSuccess(res) {
      const { errMsg, resultStr: code } = res;
      if (errMsg === 'scanQRCode:ok') {
        this.code = code;
        const { is_usable_code: result } = await checkCode({ code });
        if (result === 1) {
          this.isUpload = true;
        }
        // this.$toast.success(code);
      }
    },
    handleFieldChange(e) {
      this.imgUrl = e;
    },
    getSdkConfig() {
      const params = {
        path: this.path,
      };
      getMapSdk(params).then((res) => {
        wx.config(res);
      });
    },
    submit() {
      if (this.imgUrl.length > 10) {
        addFaceInfo({ code: this.code, face: this.imgUrl }).then((res) => {
          if (res) {
            this.$toast.success('上传成功');
            this.$router.push({
              path:'/user_info/index'
            })
          }
        });
      }else{
        this.$toast.fail('图片未上传')
      }
    },
  },
  created() {
    if (!isIOS()) {
      this.getSdkConfig();
    }
  },
  mounted() {},
};
</script>
<style lang='less' scoped>
.page {
  padding: 15px;
}
</style>